import { Component, OnInit, EventEmitter } from '@angular/core';
import { toast, MaterializeAction } from 'angular2-materialize';
import { PurchaseOrder, PurchaseOrderService } from '../../services/purchase-order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { CompanyService, Company } from '../../services/company.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { FiscalData } from '../../services/fiscal-data.service';
import { Globals } from '../../globals';
import { CustomerBillData } from '../../services/customer-bill.service';
import { AuthService } from '../../services/auth.service';



@Component({
  selector: 'app-display-purchase-order',
  templateUrl: './display-purchase-order.component.html',
  styleUrls: ['./display-purchase-order.component.css'] 
})
export class DisplayPurchaseOrderComponent implements OnInit {//f

  // TEMPORARY SOLUTION
  tempz = 0;
  company: any;

  prForOrders: any;
  htmlForEmail: string;

  purchaseOrder: any;
  purchaseObject: any = {};
  sid: string;
  formWhere: string;

  purchaseOrderSub: Subscription;
  companySub: Subscription;

  sortablejsOptions;

  constructor(
    private purchaseOrderService: PurchaseOrderService,
    private companyService: CompanyService,
    private settingsService: CatalogsSettingsService,
    private billData: CustomerBillData,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {
    this.formWhere = this.activatedRoute.snapshot.paramMap.get('from');
    if(this.formWhere == 'fromEmail'){
      toast('¡Correo enviado con éxito!', 8000);
    }
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
    this.companySub = this.companyService.getCompany().subscribe(company => {
      this.company = company;
      this.company.numInt = company.numInt ? ' Int. ' + company.numInt : '';
      this.purchaseObject.companyName = company.name;
      this.purchaseObject.companyAddress = company.street + ' ' + company.numExt + company.numInt + '&emsp;' + company.colony + '&emsp;' + company.municipality + '&emsp;' + company.city + '&emsp;C.P. ' + company.postCode;
      this.purchaseObject.companyPhone = company.phoneOne;
      //this.purchaseObject.companyEmail = company.email;
      this.purchaseObject.emailContent = '';
      this.purchaseObject.companyWebPage = company.webPage || '',
      this.purchaseObject.companySupAddress = company.supAddress || '';
      this.purchaseObject.companySupNotes = company.supNotes || '';
      this.purchaseObject.imageURL = company.imageURL;//.replace(/&/g,'/A;/').replace(/%/g,'/P;/');
    });
    this.purchaseObject.companyEmail = this.authService.currentUser.email;
    this.purchaseObject.copyEmails = '';
    let setSub = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      setSub.unsubscribe();
      this.purchaseObject.isoDescription = (settings.isoDescriptions || {})['OdC'] || '';
    })
    this.sortablejsOptions = {
      onUpdate: (event: any) => {
        this.purchaseObject.prForOrders = this.prForOrders;
      }
    }
  }

  ngOnInit() {
    /* var imported = document.createElement('script');
    imported.src = '/path/to/imported/script';
    document.head.appendChild(imported); */

    this.purchaseOrderSub = this.purchaseOrderService.getPurchaseOrder(this.sid).subscribe(([data]) => {
      let {currency='key0'} = data;
      currency = this.billData.currencySelect[currency].code;
      this.purchaseOrder = {...data, currency};
      this.prForOrders = data.prForOrders;
      this.purchaseObject.folio = `OCS-${data.folio}`;
      this.purchaseObject.date = data.date;
      this.purchaseObject.currency = currency;
      this.purchaseObject.notes = data.notes ? 'Notas: ' + data.notes : '' ;
      this.purchaseObject.prForOrders = data.prForOrders;
      this.purchaseObject.supplierName = data.supplierObj.name;
      this.purchaseObject.supplierEmail = data.supplierObj.email;
      this.purchaseObject.supplierRfc = data.fiscalDataObj.rfc;
      let { municipality, neighborhood, postCode, stateId: fStateId, street, countryId: fCountryId, externalNumber, internalNumber, businessName, phone } = <FiscalData>data.fiscalDataObj;
      this.purchaseObject.fiscalData = { municipality, neighborhood, postCode, state: Globals.STATES[fStateId].name, street, country: Globals.COUNTRIES[fCountryId].name, externalNumber, internalNumber, businessName, phone };
    });
  }
  ngOnDestroy() {
    this.purchaseOrderSub.unsubscribe();
    this.companySub.unsubscribe();
  }
  getBack() {
    if(this.formWhere == 'fromReq'){
      this.router.navigate(['/purchase_request']);
    } else {
      this.router.navigate(['/purchase_order']);
    }
  }
  onEdit(){
    localStorage.returnToDisplay = 'true';
    console.log(localStorage.returnToDisplay)
    this.router.navigate([`/edit_purchase_order/${this.sid}`]);
  }

  onCopyEmailsInput(){
    this.purchaseObject.copyEmails = this.purchaseObject.copyEmails.replace(new RegExp(' ', 'g'), '');
  }

  get dataPhp(){
    return JSON.stringify(this.purchaseObject);
  }

  modalActionsMail = new EventEmitter<string|MaterializeAction>();
  modalParamsMail = [{dismissible: true}];
  xmlMail: string; pdfMail: string; notesMail: string;
  openModalMail() {
    this.purchaseObject.supplierEmail = this.purchaseOrder.supplierObj.email;
    this.modalActionsMail.emit({ action: 'modal', params: ['open'] });
  }
  closeModalMail() { this.modalActionsMail.emit({ action: 'modal', params: ['close'] }); }
  get mailValid(){ return this.purchaseObject && this.purchaseObject.companyEmail && this.purchaseObject.supplierEmail }
}

